import { cn } from '@tribeplatform/react-components/utils/cn'

import { TreeItemProps } from '../types.js'

const DEPTH = 20

export function TreeItemComponent({
  item,
  depth,
  children,
  arrow,
  context,
  info,
}: TreeItemProps) {
  return (
    <li {...context.itemContainerWithChildrenProps} className="flex flex-col">
      <div
        {...context.itemContainerWithoutChildrenProps}
        className={cn(
          'flex flex-row gap-1 items-center w-full',
          'text-content-subdued',
          context.isFocused && 'bg-surface-hovered text-content',
          context.isSelected && 'bg-surface-pressed text-content',
          context.isDraggingOver && 'bg-action-primary text-content',
        )}
      >
        <div
          {...context.interactiveElementProps}
          className="w-full cursor-pointer outline-none focus-visible:outline-2"
        >
          <div
            className="flex flex-row items-center gap-1 grow"
            style={{ paddingInlineStart: `${depth * DEPTH}px` }}
          >
            {arrow}
            {item.data.render({ context, info })}
          </div>
        </div>
      </div>
      {children}
    </li>
  )
}
